import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from 'src/app/shared/constants';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';

@Component({
  selector: 'app-kpi-configuration',
  templateUrl: './kpi-configuration.component.html',
  styleUrl: './kpi-configuration.component.scss'
,  standalone: false
})
export class KpiConfigurationComponent {
  constants: Constants = new Constants();
  kpiData: IKpiResponse[] = [];
  constructor(private baseHttpService: BaseHttpService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.getKpiData();                  
  }
  getImageUrl(kpiImage: string): string {
    return `assets/icons/${kpiImage}`;
}
  getKpiData(): void {
    this.baseHttpService.get(this.constants.getKPIResponses).subscribe((result) => {
      if(result != null){
      this.kpiData = result;
      this.kpiData.sort((a, b) => a.kpiConfiguration.sequence - b.kpiConfiguration.sequence);
      }
      this.spinner.hide();
    });
  }
}

export interface IKpiResponse {
  kpiConfiguration: KpiConfiguration;
  stats: string;
}

export class KpiConfiguration {
  kpiConfigurationId: number;
  kpiId: number;
  userOrAcross: string;
  grouptoDisplay?: string;
  displayText?: string;
  backgroundColor?: string;
  sequence: number;
  groupId: string;
  kpiDetails: KpiDetails;
}
export class KpiDetails {
  kpiId: number;
  kpiName: string;
  guid: string;
  kpiType: string;
  kpiImage: string;
}